const namespaced = true;

const defaultState = () => {
  return {
    drawer: true,
    name:"Home",
    logout:false,
    message:'',
    unauth:false,
  };
};

const state = defaultState();
const actions = {};
const mutations = {
  SET_LOGOUT(state,logout){
    state.logout = logout
    state.message = "Are you sure you want to log out?"
  },
  resetState(state) {
    Object.assign(state, defaultState());
  },
  SET_DRAWER(state, drawer) {
    state.drawer = drawer;
  },
  SET_NAME(state,name){
    state.name = name
  },
  SET_UN_AUTH(state){
    state.logout = true;
    state.unauth = true;
    state.message = "Unauthorized process.You will redirecting to login."
  }
};
const getters = {};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};
